import { Navigate } from "react-router-dom";
import React, { useMemo } from "react";
import useAuth from "../hooks/useAuth.js";

interface Props {
    children: JSX.Element;
}

export default function ProtectedRoute(props: Props) {
    const { children } = props;

    const { isAuthed, authChecked } = useAuth();

    const output = useMemo(() => {
        if (isAuthed) {
            return children;
        } else if (authChecked) {
            return <Navigate to="/login" replace />;
        }
    }, [authChecked, children, isAuthed]);

    return output || null;
}
